import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import {
  createListSalesmen,
  deleteListSalesmen,
  getListSalesmenList,
  updateListSalesmen,
  getListCountry,
  getAllSalesmenSync,
  getLanguageList,
} from "../../services/MoloniServices";
import Select from "react-select";

const SalesMen = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const navigate = useNavigate();

  const location = useLocation();
  const [activeTab, setActiveTab] = useState("tpsoft");

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: "269134",
    created_from: activeTab === "tpsoft" ? 1 : 2,
  });
  const { t } = useTranslation();

  const [totalRecords, setTotalRecords] = useState(0);
  const [salesmenList, setSalesMenList] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delType, setDelType] = useState("");
  const [modifyModal, setModifyModal] = useState(false);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [salesmenData, setSalesmenData] = useState({
    id: "",
    vat: "",
    number: "",
    name: "",
    language_id: "",
    base_commission: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    moloni_id: "",
  });

  let errorsObj = {
    vat: "",
    number: "",
    name: "",
    language_id: "",
    base_commission: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [isWareHouseLoading, setIsWareHouseLoading] = useState(false);
  const [languageList, setLanguageList] = useState([]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    setParams((prevParams) => ({
      ...prevParams,
      created_from: tab === "tpsoft" ? 1 : 2,
    }));
  };

  const handleAddModal = () => {
    setModifyModal(true);
  };

  const handleCloseModal = () => {
    setModifyModal(false);
    setSalesmenData({
      id: "",
      name: "",
      business_name: "",
      email: "",
      address: "",
      city: "",
      zip_code: "",
      phone: "",
      fax: "",
      website: "",
      notes: "",
      documents_footnote: "",
      email_sender_name: "",
      email_sender_address: "",
      country_id: "",
      moloni_id: "",
    });

    setErrors("");
  };
  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value);
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
      localStorage.setItem("lastVisitedPage", e.selected + 1);
    }
    setParams(paramsObj);
  };

  const fetchTemplate = () => {
    let data = { ...params };
    getListSalesmenList(data)
      .then((response) => {
        setSalesMenList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      fetchTemplate(data);
    },
    [params],
  );

  const handleWareHouseSync = () => {
    setIsWareHouseLoading(true);

    let data = { company_id: "269134" };
    getAllSalesmenSync(data)
      .then((response) => {
        toast.success(response.data.message);

        let data = { ...params };
        getListSalesmenList(data)
          .then((response) => {
            setSalesMenList(response.data.data);
            setTotalRecords(response.data.total);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          })
          .finally(() => {
            setIsWareHouseLoading(false);
          });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsWareHouseLoading(false);
      });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTimeZoneList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getLanguageList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].language_id,
            label: response.data[i].title,
          });
        }

        setLanguageList(list);
      })
      .catch((err) => {});
  }, []);

  const onDeleteModalClose = () => {
    setDelModal(false);
  };
  const onEditDetails = (e, item) => {
    setModifyModal(true);
    setSalesmenData({
      id: item?.id,
      vat: item?.vat,
      number: item?.number,
      name: item?.name,
      language_id: item?.language_id,
      base_commission: item?.base_commission,
      qty_copies_document: item?.qty_copies_document,
      notes: item?.notes,
      country_id: item?.country_id,
      address: item?.address,
      zip_code: item?.zip_code,
      city: item?.city,
      email: item?.email,
      website: item?.website,
      phone: item?.phone,
      fax: item?.fax,
      moloni_id: item?.moloni_id,
    });
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelType(item.moloni_id);
    setDelModal(true);
  };

  const onDestroyBank = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { salesmen_id: delType, company_id: "269134" };
    deleteListSalesmen(data)
      .then((response) => {
        let data = { ...params };

        fetchTemplate(data);
        toast.success(response.data.message);
        setDelType("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!salesmenData.vat) {
      errorObj.vat = `vat is required.`;
      error = true;
    }

    if (!salesmenData.number) {
      errorObj.number = `Number is required.`;
      error = true;
    }

    if (!salesmenData.name) {
      errorObj.name = `Name is required.`;
      error = true;
    }

    if (!salesmenData.language_id) {
      errorObj.language_id = `Language is required.`;
      error = true;
    }

    if (!salesmenData.base_commission) {
      errorObj.base_commission = `Base commission is required.`;
      error = true;
    }

    if (!salesmenData.qty_copies_document) {
      errorObj.qty_copies_document = `Qty copies document is required.`;
      error = true;
    }

    if (!salesmenData.address) {
      errorObj.address = `Address is required.`;
      error = true;
    }

    if (!salesmenData.city) {
      errorObj.city = `City is required.`;
      error = true;
    }

    if (!salesmenData.zip_code) {
      errorObj.zip_code = `Zip code is required.`;
      error = true;
    }

    if (!salesmenData.country_id) {
      errorObj.country_id = `Country is required.`;
      error = true;
    }

    if (salesmenData.email) {
      const isValidGmail = /^[a-zA-Z0-9._%+-]+@gmail\.com$/.test(
        salesmenData.email,
      );
      if (!isValidGmail) {
        errorObj.email =
          "Email must be a valid Gmail address (e.g., name@gmail.com)";
        error = true;
      }
    }

    if (salesmenData.website) {
      const isValidUrl = /^https?:\/\//.test(salesmenData.website);
      if (!isValidUrl) {
        errorObj.website = "Website must start with http:// or https://";
        error = true;
      }
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      vat: salesmenData?.vat,
      number: salesmenData?.number,
      name: salesmenData?.name,
      language_id: salesmenData?.language_id,
      base_commission: salesmenData?.base_commission,
      qty_copies_document: salesmenData?.qty_copies_document,
      notes: salesmenData?.notes,
      country_id: salesmenData?.country_id,
      zip_code: salesmenData?.zip_code,
      city: salesmenData?.city,
      email: salesmenData?.email,
      website: salesmenData?.website,
      phone: salesmenData?.phone,
      fax: salesmenData?.fax,
      address: salesmenData?.address,
    };

    let updateData = {
      company_id: "269134",
      id: salesmenData?.id,
      vat: salesmenData?.vat,
      number: salesmenData?.number,
      name: salesmenData?.name,
      language_id: salesmenData?.language_id,
      base_commission: salesmenData?.base_commission,
      qty_copies_document: salesmenData?.qty_copies_document,
      notes: salesmenData?.notes,
      country_id: salesmenData?.country_id,
      zip_code: salesmenData?.zip_code,
      city: salesmenData?.city,
      email: salesmenData?.email,
      website: salesmenData?.website,
      phone: salesmenData?.phone,
      fax: salesmenData?.fax,
      address: salesmenData?.address,

      salesmen_id: salesmenData?.moloni_id,
    };

    if (salesmenData?.id) {
      updateListSalesmen(updateData)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchTemplate(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setSalesmenData({
            id: "",
            vat: "",
            number: "",
            name: "",
            language_id: "",
            base_commission: "",
            qty_copies_document: "",
            notes: "",
            country_id: "",
            address: "",
            zip_code: "",
            city: "",
            email: "",
            website: "",
            phone: "",
            fax: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createListSalesmen(data)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchTemplate(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setSalesmenData({
            id: "",
            vat: "",
            number: "",
            name: "",
            language_id: "",
            base_commission: "",
            qty_copies_document: "",
            notes: "",
            country_id: "",
            address: "",
            zip_code: "",
            city: "",
            email: "",
            website: "",
            phone: "",
            fax: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-entities")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-vat ms-auto mb-2">{t("salesmen")}</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-vat m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control input-search"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder="Search"
                      ></input>
                    </div>

                    <div className="card-vat m-0 float-right d-flex">
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        // onClick={handleAddModal}
                        onClick={() => navigate("/add-salesMen")}
                      >
                        <i className="bi bi-plus-lg"></i>
                        <span className="ms-2">{t("Add")}</span>
                      </button>
                      {activeTab === "moloni" && (
                        <button
                          type="button"
                          className="btn mr-2"
 style={{
                            background: "#81bb42",
                            width: "52px",
                            height: "36px",
                          }}                          onClick={handleWareHouseSync}
                          disabled={isWareHouseLoading}
                        >
                          {isWareHouseLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <i className="bi bi-arrow-repeat"></i>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="card-body fuelCardB">
                    <div className="tabs-section">
                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "tpsoft" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("tpsoft")}
                            style={{ cursor: "pointer" }}
                          >
                            TPSoft
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "moloni" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("moloni")}
                            style={{ cursor: "pointer" }}
                          >
                            Moloni
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content">
                        <div
                          className={`tab-pane fade ${
                            activeTab === "tpsoft" ? "show active" : ""
                          }`}
                        >
                          <div
                            className="vehicleThBg table-responsive  table-responsive-vehicle"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("vat")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("number")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("phone")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("base_commission")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("email")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {salesmenList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{item.vat || "-"}</td>
                                        <td>{item.number}</td>
                                        <td>{item.phone || "-"}</td>
                                        <td>{item.base_commission || "-"}</td>
                                        <td>{item.email || "-"}</td>

                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive =
                                                  document.querySelector(
                                                    ".table-responsive",
                                                  );
                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                // onClick={(e) =>
                                                //   onEditDetails(e, item)
                                                // }

                                                onClick={() => {
                                                  navigate(
                                                    `/update-salesMen/${item.id}`,
                                                    {
                                                      state: item,
                                                    },
                                                  );
                                                }}
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-pencil"></i>
                                                </div>
                                                <span>{t("edit")}</span>
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                href="#/action-2"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, item)
                                                }
                                              >
                                                <div className="trash-btn">
                                                  <a className="delete-btn">
                                                    <i className="bi bi-trash3"></i>
                                                  </a>
                                                </div>
                                                <span>{t("delete")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {salesmenList && salesmenList?.length === 0 && (
                                <tr>
                                  <td colSpan={7} className={`text-center`}>
                                    {t("no_record_found")}
                                  </td>
                                </tr>
                              )}
                            </table>
                          </div>
                        </div>

                        <div
                          className={`tab-pane fade ${
                            activeTab === "moloni" ? "show active" : ""
                          }`}
                        >
                          <div
                            className="vehicleThBg table-responsive table-responsive1  table-responsive-vehicle"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("vat")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("number")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("phone")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("base_commission")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("email")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {salesmenList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{item.vat || "-"}</td>
                                        <td>{item.number}</td>

                                        <td>{item.phone || "-"}</td>
                                        <td>{item.base_commission || "-"}</td>
                                        <td>{item.email || "-"}</td>

                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive1 =
                                                  document.querySelector(
                                                    ".table-responsive1",
                                                  );
                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive1.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive1.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                // onClick={(e) =>
                                                //   onEditDetails(e, item)
                                                // }

                                                onClick={() => {
                                                  navigate(
                                                    `/update-salesMen/${item.id}`,
                                                    {
                                                      state: item,
                                                    },
                                                  );
                                                }}
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-pencil"></i>
                                                </div>
                                                <span>{t("edit")}</span>
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                href="#/action-2"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, item)
                                                }
                                              >
                                                <div className="trash-btn">
                                                  <a className="delete-btn">
                                                    <i className="bi bi-trash3"></i>
                                                  </a>
                                                </div>
                                                <span>{t("delete")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {salesmenList && salesmenList?.length === 0 && (
                                <tr>
                                  <td colSpan={7} className={`text-center`}>
                                    {t("no_record_found")}
                                  </td>
                                </tr>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="fuelCF">
            <div
              className="card-footer card-footer-part clearfix card-footer"
              style={{ marginTop: "-26px" }}
            >
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{t("delete_salesmen")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {t("Are you sure you want to delete this Salesmen")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyBank}
            >
              {t("delete")} <i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyModal} size="xl">
        <ModalHeader>{t("salesmen")}</ModalHeader>
        <Form method={`post`} onSubmit={handleSubmitForm}>
          <ModalBody>
            <div className="row">
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("vat")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={salesmenData.vat}
                        onChange={(e) => {
                          setSalesmenData({
                            ...salesmenData,
                            vat: e.target.value,
                          });
                        }}
                        name={`vat`}
                        maxLength={50}
                        placeholder="vat"
                      />
                    </div>
                    {errors.vat && (
                      <span className="input-error">{errors.vat}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("number")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={salesmenData.number}
                        onChange={(e) => {
                          setSalesmenData({
                            ...salesmenData,
                            number: e.target.value,
                          });
                        }}
                        name={`number`}
                        maxLength={50}
                        placeholder="number"
                      />
                    </div>
                    {errors.number && (
                      <span className="input-error">{errors.code}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("name")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={salesmenData.name}
                        onChange={(e) => {
                          setSalesmenData({
                            ...salesmenData,
                            name: e.target.value,
                          });
                        }}
                        name={`name`}
                        maxLength={50}
                        placeholder="name"
                      />
                    </div>
                    {errors.name && (
                      <span className="input-error">{errors.code}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("language")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={languageList}
                        value={languageList.find(
                          (item) => item.value == salesmenData.language_id,
                        )}
                        onChange={(selectedOption) => {
                          setSalesmenData({
                            ...salesmenData,
                            language_id: selectedOption
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Language"}
                      />
                      {errors.language_id && (
                        <span className="input-error">
                          {errors.language_id}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("base_commission")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={salesmenData.base_commission}
                        onChange={(e) => {
                          setSalesmenData({
                            ...salesmenData,
                            base_commission: e.target.value,
                          });
                        }}
                        name={`base_commission`}
                        maxLength={50}
                        placeholder="Base commission"
                      />
                    </div>
                    {errors.base_commission && (
                      <span className="input-error">
                        {errors.base_commission}
                      </span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("qty_copies_document")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={salesmenData.qty_copies_document}
                        onChange={(e) => {
                          setSalesmenData({
                            ...salesmenData,
                            qty_copies_document: e.target.value,
                          });
                        }}
                        name={`qty_copies_document`}
                        maxLength={50}
                        placeholder="Qty copies document"
                      />
                    </div>
                    {errors.qty_copies_document && (
                      <span className="input-error">
                        {errors.qty_copies_document}
                      </span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("notes")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={salesmenData.notes}
                        onChange={(e) => {
                          setSalesmenData({
                            ...salesmenData,
                            notes: e.target.value,
                          });
                        }}
                        name={`notes`}
                        maxLength={50}
                        placeholder="notes"
                      />
                    </div>
                    {errors.notes && (
                      <span className="input-error">{errors.notes}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("country")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={timeZoneList}
                        value={timeZoneList.find(
                          (item) => item.value == salesmenData.country_id,
                        )}
                        onChange={(selectedOption) => {
                          setSalesmenData({
                            ...salesmenData,
                            country_id: selectedOption
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Country"}
                      />
                      {errors.country_id && (
                        <span className="input-error">{errors.country_id}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("address")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={salesmenData.address}
                        onChange={(e) => {
                          setSalesmenData({
                            ...salesmenData,
                            address: e.target.value,
                          });
                        }}
                        name={`address`}
                        maxLength={50}
                        placeholder="Address"
                      />
                    </div>
                    {errors.address && (
                      <span className="input-error">{errors.address}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("city")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={salesmenData.city}
                        onChange={(e) => {
                          setSalesmenData({
                            ...salesmenData,
                            city: e.target.value,
                          });
                        }}
                        name={`city`}
                        maxLength={50}
                        placeholder="City"
                      />
                    </div>
                    {errors.city && (
                      <span className="input-error">{errors.city}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("zip_code")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={salesmenData.zip_code}
                        onChange={(e) => {
                          setSalesmenData({
                            ...salesmenData,
                            zip_code: e.target.value,
                          });
                        }}
                        name={`zip_code`}
                        maxLength={50}
                        placeholder="Zip code"
                      />
                    </div>
                    {errors.zip_code && (
                      <span className="input-error">{errors.zip_code}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("phone")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={salesmenData.phone}
                        onChange={(e) => {
                          setSalesmenData({
                            ...salesmenData,
                            phone: e.target.value,
                          });
                        }}
                        name={`phone`}
                        placeholder="Phone"
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("fax")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={salesmenData.fax}
                        onChange={(e) => {
                          setSalesmenData({
                            ...salesmenData,
                            fax: e.target.value,
                          });
                        }}
                        name={`fax`}
                        placeholder="Fax"
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("email")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={salesmenData.email}
                        onChange={(e) => {
                          setSalesmenData({
                            ...salesmenData,
                            email: e.target.value,
                          });
                        }}
                        name={`email`}
                        maxLength={50}
                        placeholder="Contact email"
                      />
                      {errors.email && (
                        <span className="input-error">{errors.email}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("website")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={salesmenData.website}
                        onChange={(e) => {
                          setSalesmenData({
                            ...salesmenData,
                            website: e.target.value,
                          });
                        }}
                        name={`website`}
                        placeholder="website"
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3"></div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyButtonLoad}
              onClick={handleCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("submit")} <i className="bi bi-check2"></i>
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default SalesMen;
